export const P00037TauxAbaissement = [
  { label: '0 %', ref: 0 },
  { label: '10 %', ref: 10 },
  { label: '20 %', ref: 20 },
  { label: '30 %', ref: 30 },
  { label: '40 %', ref: 40 },
  { label: '50 %', ref: 50 },
  { label: '60 %', ref: 60 },
  { label: '70 %', ref: 70 },
  { label: '80 %', ref: 80 },
  { label: '90 %', ref: 90 },
];
